import React from 'react';

export function Terms() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 container mx-auto flex flex-col items-center">
      <div className="text-center space-y-6 mb-16 max-w-4xl">
        <h1 className="font-display text-4xl md:text-7xl uppercase text-white leading-none">
          Terms & <br/>
          <span className="text-[var(--color-sansi-green)]">Conditions</span>
        </h1>
      </div>

      <div className="max-w-4xl w-full text-lg text-gray-300 font-light leading-relaxed space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
          <p>
            Welcome to Sansi Eco Foods. By using our website and purchasing our products, you agree to these terms and conditions.
            Please read them carefully.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">2. Products</h2>
          <p>
            We ensure our dehydrated fruits and vegetables are 100% natural, chemical-free, and of the highest quality.
            However, due to the nature of natural products, slight variations in color and texture may occur.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">3. Ordering & Payment</h2>
          <p>
            All orders are subject to availability. Prices are listed in LKR and may change without notice. 
            Payment must be made at the time of order via our secure payment gateways or Cash on Delivery where applicable.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">4. Shipping & Delivery</h2>
          <p>
            We deliver across Sri Lanka. Delivery times may vary depending on location. We are not liable for delays 
            caused by courier services or unforeseen circumstances.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">5. Returns & Refunds</h2>
          <p>
            If you receive a damaged or incorrect product, please contact us within 24 hours. We will arrange a replacement 
            or refund upon verification.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-white mb-4">6. Contact Us</h2>
          <p>
            For any queries, please reach out to us at contact@sansiecofoods.com or call our customer service hotline.
          </p>
        </section>
      </div>
    </div>
  );
}
